<template>
	<div id="layout-root">
		<ToTop class="totop" />
		<router-view />
	</div>
</template>

<script>
import ToTop from './components/toTop.vue';

export default {
	name: 'App',
	components: {
		ToTop,
	},
	inject: {
		deviceType: { from: 'deviceType', default: 'desktop' },
	},
	computed: {
		resolvedDeviceType() {
			if (typeof window !== 'undefined') {
				const w = window.innerWidth || document.documentElement.clientWidth;
				return w < 768 ? 'mobile' : 'desktop';
			}
			return this.deviceType;
		},
		isMobile() {
			return this.resolvedDeviceType === 'mobile';
		},
	},
	mounted() {
		this.$logEvent('show_gbhome');
	},
};
</script>
